import React from 'react';
import { Spacer } from 'src/common/Spacer';
import { useRiskIntel } from '../useRiskIntel';
import { SectionHeader } from '../comps/SectionHeader';
import { FetchingState } from '../comps/FetchingState';
import { FrequencyPanel } from '../comps/FrequencyPanel';

export const FrequencyStep: React.FC = () => {
  const { session, busy, chooseFrequency } = useRiskIntel();
  const frequency = session?.frequency;

  return (
    <div>
      <SectionHeader>Frequency Research</SectionHeader>
      <Spacer $px={24} />
      {frequency ? (
        <FrequencyPanel
          frequency={frequency}
          // Disable the choose buttons whenever anything's loading (incl. the impacts rung generating after a choice).
          pending={busy}
          onChoose={(chosenValue, chosenSourceId) => chooseFrequency(chosenValue, chosenSourceId)}
        />
      ) : (
        <FetchingState
          title="Fetching Frequency Insights"
          subtitle="The risk intel is fetching industry insights to help quantify your frequency"
        />
      )}
    </div>
  );
};
